// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nr-1";
export var stateContainer = "_nr-0";